<svelte:options customElement={{ tag: "bt-modal-container", shadow: "none", }} />

<script lang="ts">
  import { modalStore } from '$shared/modal/modalStore';

  import AddToCurations from "$comp/curations/AddToCurations.svelte";
  import AddExternalLinkModal from "$comp/curations/AddExternalLinkModal.svelte";

  export let doneText = 'Done';
  export let addToCurationModalTitle = 'Add to Curation';
  export let addToCurationTextEnter = 'Enter';
  export let addToCurationTextPlaceholder = 'New Curation';
  export let addToCurationListHeader = 'Your Curations';

  $: modalName = $modalStore.modalName
</script>

<div>
  {#if modalName === 'addToCuration'}
    <AddToCurations
      {doneText}
      {addToCurationModalTitle}
      {addToCurationTextEnter}
      {addToCurationTextPlaceholder}
      {addToCurationListHeader}
      {...$modalStore.modalData}
    />
  {/if}
  {#if modalName === 'externalLinkModal'}
    <AddExternalLinkModal {...$modalStore.modalData} />
  {/if}
</div>
